import React, { useEffect, useState } from "react";
import axios from "axios";
import Slider from "react-slick";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link, useNavigate } from "react-router-dom";
import { Card } from "react-bootstrap";

function Categories() {
  const navigate = useNavigate();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    scrollToTop();
  }, [navigate]);

  const [collectionItems, setCollectionItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchProduct();
  }, []);

  const baseURL = "https://karstar.in/";
  console.log(baseURL);
  const fetchProduct = async () => {
    try {
      const response = await axios.get(
        `${baseURL}/api/client_api/productCategories/index.php`
      );
      const fetchedItems = response.data;
      console.log(fetchedItems);
      setCollectionItems(fetchedItems);
      setIsLoading(false);
    } catch (err) {
      setError(err.message);
      setIsLoading(false);
    }
  };

  const GenderCard = ({ item }) => (
    <Link to={`/collections/${item.name}`}>
      <Card className="me-1 bg-transparent card-hover gendersCard border-0">
        <div className="">
          <Card.Img
            src={baseURL + item.image_path}
            alt="Gender Image"
            style={{ borderRadius: "10px" }}
          />
          {/* <div className="card-overlay"></div> */}
        </div>
        <Card.Title
          className="text-center my-3 fw-bold"
          style={{ fontSize: "14px" }}
        >
          {item.name}
        </Card.Title>
      </Card>
    </Link>
  );

  const Breadcrumb = ({ product }) => {
    return (
      <div className="breadcrumb-container">
        <div className="breadcrumb">
          <Link to="/collections" className="breadcrumb-item text-black me-2">
            Karstar
          </Link>
          <Link to="/categories" className="breadcrumb-item text-black me-2">
            Collections
          </Link>
        </div>
        <h2 className="heading-title text-mfi py-2 text-capitalize fw-bold gradient-text">
          Shop By category
        </h2>
      </div>
    );
  };

  return (
    <div className="sectionView container mt-3">
      <Breadcrumb />
      {error && <div>{error}</div>}
      <Row className="g-2">
        {collectionItems
          .slice() // Create a shallow copy of the array
          .sort((a, b) => {
            const priority = [
              "All Products",
              "Instant Geysers",
              "Portable Washing Machine",
              "Semi Automatic washing Machine",
              "High Pressure Washers",
              "Vaccum Cleaners",
              "Water Pumps",
              "Mixers and Wet Grinders",
              "Gas Stoves",
              "Chimneys",
              "Air coolers",
              "Shoe Racks",
              "Korai Mat",
              "Sofa cum Beds",
            ];
            const aPriority = priority.indexOf(a.name);
            const bPriority = priority.indexOf(b.name);

            // Prioritize the categories in the priority array
            if (aPriority !== -1 && bPriority !== -1) {
              return aPriority - bPriority;
            }
            if (aPriority !== -1) return -1; // a has priority
            if (bPriority !== -1) return 1; // b has priority

            // Default alphabetical sorting for others
            return a.name.localeCompare(b.name);
          })
          .map((category, index) => (
            <Col xs={4} md={3} lg={2} key={category.id}>
              <GenderCard item={category} />
            </Col>
          ))}
      </Row>
    </div>
  );
}

export default Categories;
